import React, {useState, useEffect} from 'react';
import {createPortal} from 'react-dom';
import PopupSearch from './PopupSearch.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function Select({show, close, value, options, showNone = true, returnValue, popupClassName = ''}) {
	const popupAnimationMs = 300;
	const [search, setSearch] = useState('');
	const {shouldRender, isClosing} = usePopupAnimation(show, popupAnimationMs);
	const isSelected = (optionValue) => String(value) === String(optionValue);
	const safeOptions = Array.isArray(options) ? options : [];
	const normalizedSearch = search.trim().toLowerCase();

	useEffect(() => {
		if (show) {
			setSearch('');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]);

	const filteredOptions = safeOptions.filter((item) => {
		if (!normalizedSearch) {
			return true;
		}

		return item.NAME?.toLowerCase().includes(normalizedSearch);
	});

	const list = filteredOptions.map((item, index) => {
		return (
			<div
				className={`select_item ${isSelected(item.ID) ? 'selected' : ''}`}
				key={'item_' + index}
				onClick={() => {
					returnValue(item);
					close();
				}}
			>
				<div className="txt_l">{item.NAME}</div>
			</div>
		);
	});

	if (!shouldRender) {
		return null;
	}

	const popup = (
		<div className={`popup${isClosing ? ' popup--closing' : ''}`} style={{zIndex: '2100'}} onClick={close}>
			<div className={`popup_content form-select-popup__content${popupClassName ? ` ${popupClassName}` : ''}${isClosing ? ' popup_content--closing' : ''}`} onClick={(e) => e.stopPropagation()}>
				<div className="popup_content_in_head">
					<div className="popup_content_in_head_in">Výběr</div>
					<img
						alt=""
						className="popup_content_in_head_in-close"
						onClick={() => {
							close();
						}}
					/>
				</div>
				<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar">
					<div className="popup_content_in_body_in form-select-popup__search" style={{padding: '1rem 1rem 0rem 1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
						<PopupSearch searchValue={search} onChangeSearch={(value) => setSearch(value)} />
					</div>

					<div className="popup_content_in_body_in form-select-popup__list" style={{padding: '0rem 1rem 0rem 1rem', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
						<div className="zero h1" />

						{showNone ? (
							<div
								className={`select_item ${isSelected(0) ? 'selected' : ''}`}
								key={'item_0'}
								onClick={() => {
									returnValue({ID: 0, NAME: '[None]'});
									close();
								}}
							>
								<div className="txt_l">[None]</div>
							</div>
						) : (
							''
						)}

						{list}

						<div className="zero h1" />
					</div>
				</div>
				<div className="popup_content_in_foot">
					<div className="popup_content_in_foot_in">
						<button
							type="button"
							className="button"
							onClick={() => {
								close();
							}}
						>
							Zpět
						</button>
					</div>
				</div>
			</div>
		</div>
	);

	if (typeof document === 'undefined') {
		return popup;
	}

	return createPortal(popup, document.body);
}
